module.exports = __webpack_public_path__ + "img/washingmachine.0db2c726.png";